import { getConversationId } from './conversationId';
import { subscribePrivateChat } from './privateChatFirestore';

/**
 * Count incoming messages after lastReadId (exclusive). If lastReadId missing, all from them count.
 */
export function countUnreadPrivateMessages(messages, lastReadId, currentUserId) {
  if (!messages?.length) return 0;
  if (!lastReadId) {
    return messages.filter((m) => m.fromUserId && m.fromUserId !== currentUserId).length;
  }
  let afterCursor = false;
  let count = 0;
  for (const m of messages) {
    if (m.id === lastReadId) afterCursor = true;
    else if (afterCursor && m.fromUserId !== currentUserId) count += 1;
  }
  return count;
}

/**
 * Subscribe to each friend's conversation; emits merged message map.
 */
export function subscribePrivateMessageInbox(currentUserId, friends, onInboxUpdate) {
  if (!currentUserId || !friends?.length) {
    onInboxUpdate({ messagesByFriendId: {} });
    return () => {};
  }

  const messagesByFriendId = {};
  const emit = () => onInboxUpdate({ messagesByFriendId: { ...messagesByFriendId } });

  const unsubs = friends.map((friend) => {
    const convId = getConversationId(currentUserId, friend.id);
    if (!convId) return () => {};

    return subscribePrivateChat(convId, currentUserId, (messages) => {
      messagesByFriendId[friend.id] = messages;
      emit();
    });
  });

  return () => unsubs.forEach((u) => u());
}
